import { render, staticRenderFns } from "./TheCreditsTabsItems.vue?vue&type=template&id=6e158642&scoped=true"
import script from "./TheCreditsTabsItems.vue?vue&type=script&lang=js"
export * from "./TheCreditsTabsItems.vue?vue&type=script&lang=js"
import style0 from "./TheCreditsTabsItems.vue?vue&type=style&index=0&id=6e158642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e158642",
  null
  
)

export default component.exports